import { useEffect } from 'react';
import useSWR from 'swr';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar';
import { UsersTable } from '../components/UsersTable';
import { getAdminToken, clearAdminToken } from '../utils/auth';
import { useAppContext } from '../context/AppContext';
import api from '../utils/apiClient';

const fetcher = (url) => api.get(url).then((res) => res.data);

export default function UsersPage() {
  const navigate = useNavigate();
  const token = typeof window !== 'undefined' ? getAdminToken() : null;
  const { selectedApp } = useAppContext();

  useEffect(() => {
    if (!token) navigate('/login', { replace: true });
  }, [token, navigate]);

  const usersKey = token
    ? selectedApp
      ? `/api/admin/apps/${selectedApp.slug}/users`
      : '/api/admin/users'
    : null;

  const { data: usersData } = useSWR(usersKey, fetcher);

  useEffect(() => {
    if (usersData?.success === false && usersData.message?.includes('token')) {
      clearAdminToken();
      navigate('/login', { replace: true });
    }
  }, [usersData, navigate]);

  const handleLogout = () => {
    clearAdminToken();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-surface text-white flex">
      <Sidebar onLogout={handleLogout} />
      <main className="flex-1 p-6 overflow-y-auto">
        <header className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-serif text-white">Users Management</h1>
            <p className="text-xs text-muted mt-1">
              {selectedApp
                ? `Users from ${selectedApp.name}`
                : 'Select an app from the sidebar to view and manage its users'}
            </p>
          </div>
        </header>

        {!selectedApp && !usersData && (
          <div className="card py-12 text-center">
            <p className="text-muted text-sm">Select an app from the sidebar dropdown to load users.</p>
          </div>
        )}

        {(selectedApp || usersData) && (
          <section>
            <UsersTable users={usersData?.users || []} selectedApp={selectedApp} />
          </section>
        )}
      </main>
    </div>
  );
}
